import { ECheckoutError, EDistributorSource } from 'core/model/enums/checkout.enum';
import { ECustomerSource } from 'core/model/enums/customer.enum';
import { EServicesErrorCode } from 'core/model/enums/error-code.enum';

export const DELIVERY_CONTACT_NUMBER = '949449467';

export const PAYMENT_METHOD_NAME = {
  cash: 'Efectivo',
  transfer: 'Transferencia',
  credit: 'Credito',
};

export const TIME_MS_TO_RESTORE_SCROLL = 250;

export const NUMBER_OF_POST_ORDER_API_RETRIES = 2;
export const POST_ORDER_API_EXPONENTIAL_DELAY = 3000;

export const CHECKOUT_ERROR_BEHAVIOURS = {
  reviewMyOrdersBecauseOfDisconnectionError: {
    code: ECheckoutError.NETWORK_OR_TIMEOUT_ERROR,
    message: 'Se ha perdido la conexión, por favor dirígete Mis pedidos y confirma si tu pedido se ha generado.',
  },
};
export const CHECKOUT_ERROR_TO_HOME = [EServicesErrorCode.CHECKOUT_MINIMUM_SALE_AMOUNT_NOT_REACHED];
export const CHECKOUT_ERROR_BLOCK_CONTINUE = [
  EServicesErrorCode.CHECKOUT_BAD_USER_CONFIGURATION,
  EServicesErrorCode.CHECKOUT_DELIVERY_DATES_ERROR,
  EServicesErrorCode.CHECKOUT_NO_CODIMOD_SET,
  EServicesErrorCode.CHECKOUT_SCHEDULES_NOT_SET,
];

export const CUSTOMER_SOURCE_CONFIG = {
  [ECustomerSource.HYBRID]: [
    {
      source: 'own' as const,
      cart: 'alicorpCart' as const,
      distributor: EDistributorSource.ALICORP,
      sourceId: ECustomerSource.DEX,
    },
    {
      source: 'thirdParty' as const,
      cart: 'alliedCart' as const,
      distributor: EDistributorSource.ALLIED,
      sourceId: ECustomerSource.APUDEX,
    },
  ],
  [ECustomerSource.DEX]: [
    {
      source: 'own' as const,
      cart: 'generalCart' as const,
      distributor: EDistributorSource.GENERAL,
      sourceId: ECustomerSource.DEX,
    },
  ],
  [ECustomerSource.APUDEX]: [
    {
      source: 'thirdParty' as const,
      cart: 'generalCart' as const,
      distributor: EDistributorSource.GENERAL,
      sourceId: ECustomerSource.APUDEX,
    },
  ],
} as const;

export const CHECKOUT_PARAMS_CONFIG = {
  [ECustomerSource.HYBRID]: {
    alicorp: 'alicorpPaymentMethodId' as const,
    allied: 'alliedPaymentMethodId' as const,
  },
  [ECustomerSource.DEX]: {
    alicorp: 'alicorpPaymentMethodId' as const,
    allied: null,
  },
  [ECustomerSource.APUDEX]: {
    alicorp: null,
    allied: 'alliedPaymentMethodId' as const,
  },
} as const;

export type TCartKey = 'alicorpCart' | 'alliedCart' | 'generalCart';

export const PAYMENT_METHOD_SOURCE_CONFIG = {
  [ECustomerSource.DEX]: {
    dex: 'generalCart' as const,
    apudex: null,
  },
  [ECustomerSource.APUDEX]: {
    dex: null,
    apudex: 'generalCart' as const,
  },
  [ECustomerSource.HYBRID]: {
    dex: 'alicorpCart' as const,
    apudex: 'alliedCart' as const,
  },
} as const;
